export async function getBalanceV4UseCase(initial_date, final_date, balanceRepository) {

    const result = await balanceRepository.get_balance_v4(initial_date, final_date);
    const balance = await new balanceRepository.model(result.data.success.arguments.file);

    if (!balance.isValid()) {
      throw new Error("Balance no valido");
    }
  
    return result;
}